<template>
  <div>
    <h2>总览</h2>
    <div class="flex-right">
      <Button
        type="warning"
        size="small"
        class="oneItem"
        @click="
          params = {};
          getData(1);
        "
        >重置</Button
      >
      <Select
        v-model="params.countries_of_interest"
        class="oneItem"
        style="width: 200px"
        placeholder="意向国家"
      >
        <Option
          v-for="item in countryOption"
          :value="item.key"
          :key="item.name"
          >{{ item.name }}</Option
        >
      </Select>
      <Select
        v-model="params.language"
        placeholder="语言"
        class="oneItem"
        style="width: 200px"
      >
        <Option
          v-for="item in languageOption"
          :value="item.key"
          :key="item.name"
          >{{ item.name }}</Option
        >
      </Select>
      <Select
        v-model="params.standardization"
        placeholder="标化"
        class="oneItem"
        style="width: 200px"
      >
        <Option
          v-for="item in standardizationOption"
          :value="item.key"
          :key="item.name"
          >{{ item.name }}</Option
        >
      </Select>

      <Button type="primary" @click="getData(1)">搜索</Button>
    </div>

    <Table class="table" :columns="col" :data="data.list" :loading="loading">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="countries_of_interest">
        <span style="font-size: 12px">
          {{
            row.student_educationInfo &&
            row.student_educationInfo.countries_of_interest.join("、")
          }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="gpa">
        <span class="nav-span" @click="navToPlanning_gpa(row)">{{
          row.student_target && row.student_target.gpa.current_gpa
        }}</span>
      </template>
      <template slot-scope="{ row }" slot="language">
        <span
          class="languageText nav-span"
          @click="navToPlanning_language(row)"
          >{{ row.languageText }}</span
        >
      </template>
      <template slot-scope="{ row }" slot="standardizationA">
        <span class="nav-span" @click="navToPlanning_standardizationA(row)">{{
          row.standardizationAText
        }}</span>
      </template>
      <template slot-scope="{ row }" slot="standardizationB">
        <span class="nav-span" @click="navToPlanning_standardizationB(row)">{{
          row.standardizationBText
        }}</span>
      </template>

      <template slot-scope="{ row }" slot="action">
        <Button type="primary" size="small" @click="navToPlanning_circuit(row)"
          >查看</Button
        >
      </template>
      <template slot-scope="{ row }" slot="activity">
        <Button type="primary" size="small" @click="navToPlanning_activity(row)"
          >查看</Button
        >
      </template>
      <template slot-scope="{ row }" slot="competition">
        <Button
          type="primary"
          size="small"
          @click="navToPlanning_competition(row)"
          >查看</Button
        >
      </template>
    </Table>

    <div class="flex-right" style="margin-top: 10px">
      <Page
        show-sizer
        :total="data.total"
        :current="data.page"
        :page-size="data.size"
        @on-change="getData"
      />
    </div>
  </div>
</template>

<script>
import bus from "@/bus.js";
export default {
  data() {
    return {
      countryOption: [
        {
          name: "All",
          key: "",
        },
        {
          name: "US",
          key: "US",
        },
        {
          name: "UK",
          key: "UK",
        },
        {
          name: "CAN",
          key: "CAN",
        },
        {
          name: "HK",
          key: "HK",
        },
        {
          name: "AUS",
          key: "AUS",
        },
      ],
      languageOption: [
        {
          name: "All",
          key: "",
        },
        {
          name: "TOEFL",
          key: "TOEFL",
        },
        {
          name: "IELTS",
          key: "IELTS",
        },
        {
          name: "PTE",
          key: "PTE",
        },
        {
          name: "Duolingo",
          key: "Duolingo",
        },
      ],
      standardizationOption: [
        {
          name: "All",
          key: "",
        },
        {
          name: "AP",
          key: "AP",
        },
        {
          name: "IB",
          key: "IB",
        },
        {
          name: "ALEVEL",
          key: "ALEVEL",
        },
        {
          name: "SAT",
          key: "SAT",
        },
        {
          name: "ACT",
          key: "ACT",
        },
        {
          name: "GRE",
          key: "GRE",
        },
        {
          name: "GMAT",
          key: "GMAT",
        },
      ],
      params: {},
      col: [
        {
          title: "No.",
          slot: "number",
          width: 140,
        },
        {
          title: "姓名",
          key: "name",
          width: 140,
        },

        // {
        //   title: "课程",
        //   key: "class",
        // },
        {
          title: "届数",
          key: "sesstion",
          width: 140,
        },
        {
          title: "意向国家",
          slot: "countries_of_interest",
          width: 200,
          align: "center",
        },
        {
          title: "GPA",
          slot: "gpa",
          width: 140,
        },
        {
          title: "语言",
          slot: "language",
          width: 160,
        },
        {
          title: "标化A",
          slot: "standardizationA",
          width: 160,
        },
        {
          title: "标化B",
          slot: "standardizationB",
          width: 160,
        },
        {
          title: "总视图",
          slot: "action",
          width: 120,
          fixed: "right",
          align: "center",
        },
        {
          title: "活动",
          slot: "activity",
          width: 120,
          fixed: "right",
          align: "center",
        },
        {
          title: "竞赛",
          slot: "competition",
          width: 120,
          fixed: "right",
          align: "center",
        },
      ],
      data: {},
      loading: false,
    };
  },
  methods: {
    async getData(page = 1) {
      this.loading = true;
      let res = await this.api({
        url: "/planning_overview/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          page: page,
          size: 10,
          ...this.params,
        },
      });

      res.list = res.list.map((item) => {
        let languageText = "";

        item.language.forEach((oneLang) => {
          if (oneLang) {
            languageText += oneLang._id + ":" + oneLang.maxScore_total + "\n";
          }
        });
        item.languageText = languageText;

        let standardizationA = [];
        let standardizationB = [];

        item.standardization.forEach((one_standardization) => {
          console.log(one_standardization);
          let add = one_standardization.type + " ";
          add += one_standardization.value.Total;
          console.log(add);

          if (one_standardization.stage == "A") {
            standardizationA.push({
              type: one_standardization.type,
              score: one_standardization.value.score,
            });
          } else if (one_standardization.stage == "B") {
            standardizationB.push({
              type: one_standardization.type,
              Total: one_standardization.value.Total,
            });
          }
        });

        let standardizationAText = "";
        standardizationA.forEach((item, index) => {
          if (index == 0) {
            standardizationAText += item.type + ": ";
          } else {
            standardizationAText += "/";
          }
          standardizationAText += item.score;
        });
        item.standardizationAText = standardizationAText;

        let standardizationBText = "";
        let maxTotal = 0;
        standardizationB.forEach((item, index) => {
          if (index == 0) {
            standardizationBText += item.type + ": ";
          }
          if (item.Total > maxTotal) {
            maxTotal = item.Total;
          }
        });

        if (maxTotal > 0) {
          item.standardizationBText = standardizationBText + maxTotal;
        }

        return item;
      });

      this.data = res;
      this.loading = false;
    },

    navToPlanning_circuit(row) {
      // console.log(row);
      bus.$emit("changeSelectedStudent", row._id);
      this.$router.push({
        path: "/planning/planning_circuit",
      });
    },

    navToPlanning_activity(row) {
      bus.$emit("changeSelectedStudent", row._id);
      this.$router.push({
        path: "/planning/planning_activity",
      });
    },
    navToPlanning_competition(row) {
      bus.$emit("changeSelectedStudent", row._id);
      this.$router.push({
        path: "/planning/planning_competition",
      });
    },
    navToPlanning_gpa(row) {
      bus.$emit("changeSelectedStudent", row._id);
      this.$router.push({
        path: "/planning/planning_gpa",
      });
    },

    navToPlanning_language(row) {
      bus.$emit("changeSelectedStudent", row._id);
      this.$router.push({
        path: "/planning/planning_language",
      });
    },

    navToPlanning_standardizationA(row) {
      bus.$emit("changeSelectedStudent", row._id);
      this.$router.push({
        path: "/planning/planning_standardization",
      });
    },

    navToPlanning_standardizationB(row) {
      bus.$emit("changeSelectedStudent", row._id);
      this.$router.push({
        path: "/planning/planning_standardization",
        query: {
          cardIndex: 1
        },
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.languageText {
  white-space: pre-line;
}
.standardizationText {
  display: inline-block;
  width: 180px;
}

.nav-span {
  color: rgb(47, 113, 255);
  text-decoration: underline;
  cursor: pointer;
}
</style>